var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncoming(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9734 3.61844C11.1426 3.78767 11.1568 4.05328 11.0157 4.23856L10.9734 4.28697L4.28813 10.9723C4.10352 11.1569 3.80421 11.1569 3.6196 10.9723C3.45038 10.803 3.43628 10.5374 3.5773 10.3521L3.6196 10.3037L10.3049 3.61844C10.4895 3.43384 10.7888 3.43384 10.9734 3.61844Z",
    fill: "#33C37E",
    stroke: "#33C37E",
    strokeWidth: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3339 10.1547C9.59498 10.1542 9.80708 10.3654 9.80764 10.6265C9.80815 10.8638 9.63366 11.0607 9.40578 11.0949L9.33593 11.1002L3.95472 11.1118C3.71667 11.1123 3.51947 10.9368 3.48599 10.7081L3.48098 10.6381L3.49212 5.25642C3.49266 4.99534 3.70475 4.78414 3.96582 4.78468C4.20316 4.78517 4.39929 4.96049 4.43258 5.18851L4.43756 5.25838L4.42769 10.1653L9.3339 10.1547Z",
    fill: "#33C37E",
    stroke: "#33C37E",
    strokeWidth: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncoming);
export default __webpack_public_path__ + "static/media/incoming.a54512378d57e384b6abcb7f4ce32bce.svg";
export { ForwardRef as ReactComponent };